import { TGetChatMessage } from 'features/chat/types'
import { baseTime } from 'lib'
import { FC, useMemo } from 'react'
import { MenuProps } from 'antd'
import { updateChatListById } from 'features/chat/reducer/ChatSlice'
import { useAppDispatch } from 'hooks'
import useAuth from 'hooks/useAuth'
import ChatMsgTextItem from './ChatMsgTextItem'

const ChatMessageItem: FC<{
 data: TGetChatMessage
 onReply?: () => void
 onDeleteMsg?: (id?: any) => void
 id: string | number
}> = ({ data, onDeleteMsg, id }) => {
 const dispatch = useAppDispatch()
 const { user } = useAuth()

 const scrollToTestDiv = (targetId?: any) => {
  const divElement = document.getElementById(`chatMsg-${targetId}`)
  if (divElement) {
   divElement.focus()
   divElement.scrollIntoView({ behavior: 'smooth', block: 'center' })
  }
 }

 const isOwnPost = useMemo(
  () => id === data?.sender?.id,
  [id, data?.sender?.id],
 )

 // isSender is effectively the same as isOwnPost based on previous logic, but let's keep consistency
 // if id matches sender id, it's the current user's message
 const isSender = isOwnPost

 return (
  <div
   tabIndex={data.id}
   id={`chatMsg-${data.id}`}
   className={`chat-message-block  ${isSender ? '' : 'you-msg'}`}
  >
   <div className={`chat-smg-item chat-msg-${data.content_type}`}>
    <header className="chat-msg-header">
     {isSender && (
      <div className={`cht-username ${!isSender ? 'text-primary' : ''}`}>
       {data.sender?.name}
      </div>
     )}

     {/* <div
      className="chat-option-menu"
      style={data.content_type === 'image' ? { top: '0' } : {}}
     >
      <Dropdown
       className="chat-msg-drop"
       overlay={<Menu items={menu} />}
       placement="topRight"
      >
       <a className="ant-dropdown-link" onClick={(e) => e.preventDefault()}>
        <i className="fas fa-angle-down" />
       </a>
      </Dropdown>
     </div> */}
    </header>
    {data.content_type !== 'image' && <div className="chat-arrow" />}
    <ChatMsgTextItem text={data.message} isSender={isSender} />
    <span className="chat-time-stamp">
     {baseTime(data?.created_at).format('hh:mm A')}{' '}
     <i className={`far ${data?.id ? 'fa-check' : 'fa-clock'}`} />
    </span>
   </div>
  </div>
 )
}

export default ChatMessageItem
